/**
 * The game board (#377) as the app's game picker and the website's games pages show it: badges
 * (most played, trending, new) and "Played 1,200 times this week". From GET /api/board, loaded once
 * per page. Without it (offline, an error) nothing shows: the board is a nicety.
 */

export interface Board {
  through: string;
  plays: Record<string, number | null>;
  mostPlayed: string[];
  trending: string[];
  new: string[];
}

let pending: Promise<Board | null> | null = null;

export function loadBoard(fetcher: typeof fetch = fetch): Promise<Board | null> {
  pending ??= fetcher("/api/board").then(
    (res) => (res.ok ? (res.json() as Promise<Board>) : null),
    () => null,
  );
  return pending;
}

/** For tests: load afresh. */
export function forgetBoardLoad(): void {
  pending = null;
}

/** The board's words for one game, most played first. */
export function badgesOf(board: Board, gameId: string): string[] {
  return [
    ...(board.mostPlayed[0] === gameId ? ["Most played"] : []),
    ...(board.trending.includes(gameId) ? ["Trending"] : []),
    ...(board.new.includes(gameId) ? ["New"] : []),
  ];
}

/** "Played 1,200 times this week", or null below the board's minimum. */
export function playsLine(board: Board, gameId: string): string | null {
  const n = board.plays[gameId];
  return typeof n === "number" ? `Played ${n.toLocaleString("en")} times this week` : null;
}
